"use strict";
// _partialFile.js

document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".p-banner-line");
  const header = document.querySelector(".p-header"); // ヘッダー要素を取得
  const headerHeight = header ? header.offsetHeight : 0; // ヘッダーの高さを取得、存在しない場合は0

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const banner = entry.target.querySelector(".js-banner-line");
        // isIntersecting: 要素が画面内にあるか
        // boundingClientRect.top < headerHeight: 要素が画面の上を通り過ぎたか
        if (entry.isIntersecting || entry.boundingClientRect.top < headerHeight) {
          // 条件：要素が画面内に表示されている、または、すでに画面上部を通過した場合
          banner.classList.add("is-fixed");
        } else {
          // 条件：上記以外（要素が表示される前の位置にある場合）
          banner.classList.remove("is-fixed");
        }
      });
    },
    {
      rootMargin: `-${headerHeight}px 0px 0px 0px`, // ヘッダーの高さ分、上方向の監視範囲を縮める
      threshold: 0.1, // 要素が10%表示されたら反応
    }
  );

  targets.forEach((target) => {
    observer.observe(target);
  });
});
